import React from "react";
import classNames from "classnames";
import Size from "shared/enums/Size";
import { InputType } from "shared/form/enum";
import { ToggleButtonConfig } from "./types";
import ToolTip from "shared/components/tooltip";
import ToggleBtnLabelPosition from "shared/enums/ToggleButton";

function getClassNames(args: { size?: Size; className?: string }) {
  return classNames(args.className, {
    toggleBtn_wrapper: true,
    smooth: true,
    [`toggleBtn--${args.size}`]: args.size
  });
}

function ToggleButton({
  labelPosition = ToggleBtnLabelPosition.LEFT,
  size = Size.MEDIUM,
  ...props
}: ToggleButtonConfig) {
  const computedClassNames = getClassNames({ size: size, className: props.className });

  const InputWrapper = React.useMemo(
    () =>
      props.disabled && props.disabledReason
        ? ({ children }: { children?: React.ReactElement }) => (
            <ToolTip content={props.disabledReason} size={Size.SMALL} interactive={false}>
              <div className={classNames({ disabled: props.disabled })}>{children}</div>
            </ToolTip>
          )
        : React.Fragment,
    [props.disabled, props.disabledReason]
  );

  return (
    <div
      className={classNames(computedClassNames, {
        changeLabelPosition: labelPosition === ToggleBtnLabelPosition.RIGHT
      })}>
      {labelPosition === ToggleBtnLabelPosition.LEFT && props.label && (
        <span className="toggleBtn_label">
          {props.label}
          {props.infoLabel && <ToolTip size={Size.SMALL} content={props.infoLabel} />}
        </span>
      )}
      <label>
        <InputWrapper>
          <React.Fragment>
            <input
              checked={props.checked}
              className="toggleBtn_checkBox"
              data-testid={props.dataTestId}
              disabled={props.disabled}
              name={props.name}
              title={props.title}
              onBlur={props.onBlur}
              onChange={props.onChange}
              type={InputType.CHECKBOX}
            />
            <span className="toggleBtn_circle smooth">
              <small className="smooth"></small>
            </span>
          </React.Fragment>
        </InputWrapper>
      </label>
      {labelPosition === ToggleBtnLabelPosition.RIGHT && props.label && (
        <span className="toggleBtn_label">
          {props.label}
          {props.infoLabel && <ToolTip size={Size.SMALL} content={props.infoLabel} />}
        </span>
      )}
    </div>
  );
}

export default ToggleButton;
